import isNull from 'lodash/isNull';
import isString from 'lodash/isString';
import HTTPError from './HTTPError';
import countAsync from '~/modules/asyncCounters/types';

function ActionError(message) {
  this.message = message;
  this.stack = Error().stack;
}
ActionError.prototype = Object.create(Error.prototype);
ActionError.prototype.name = 'ActionError';


const failAction = (dispatch, type, payload, meta) =>
  dispatch({
    type,
    payload: isString(payload) ? new ActionError(payload) : payload,
    pending: false,
    error: true,
    meta,
  });

const failActionButPassMetrics = (dispatch, type, payload, errors, meta) =>
  dispatch({
    type,
    payload: {
      message: payload,
      errors: errors,
    },
    pending: false,
    error: false, // NOTICE: to pass Metrics check
    isError: true,
    meta,
  });

const promiseAction = (dispatch, getState, type, promise, meta) => {
  const metaSubkey = meta ? JSON.stringify(meta) : '';
  const key = `${type}-${metaSubkey}`;
  const count = (getState().asyncCounters[key] + 1) || 1;
  dispatch({type: type, pending: true, meta});
  dispatch({type: countAsync.COUNT_ASYNC, payload: {key, value: count}});
  promise.then(payload => {
    if (getState().asyncCounters[key] !== count) {
      return null;
    }
    return !isNull(payload) && dispatch({type, payload, meta, pending: false});
  }).catch(payload => {
      if (payload instanceof ActionError) {
        return failAction(dispatch, type, payload, meta);
      }

      console.error(payload);

      if (getState().asyncCounters[key] !== count) {
        return null;
      }
      // meta = Object.assign(meta,{message:payload.message});
      return failAction(dispatch, type, new ActionError('Error occurred. Try again'), meta);
    });

  return promise;
};

const same = (data) => data;
const makeCreator = (type, fn = same) => (...theArgs) => ({type: type, payload: fn(...theArgs)});

export {failAction, promiseAction, makeCreator, ActionError, failActionButPassMetrics};



// WEBPACK FOOTER //
// ./src/misc/dispatch.js